import { AutogenModelExcisetaxcode, AutogenRowExcisetaxcode } from "./autogen/AutogenModelExcisetaxcode";

export class ModelExcisetaxcode extends AutogenModelExcisetaxcode<RowExcisetaxcode> {
	constructor() {
		super(RowExcisetaxcode);
	}
}

export class RowExcisetaxcode extends AutogenRowExcisetaxcode {
}